import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Ciudad, CiudadCotizador } from '~shared/models/ciudad';
import { CiudadesService } from '~shared/servicios/ciudades.service';
import { SalesService } from '../../@pages/dashboard/servicios/sales.service';
import { cotizaObjeto, formObject } from './model/cotiza';

@Component({
  selector: 'app-cotizador',
  templateUrl: './cotizador.component.html',
  styleUrls: ['./cotizador.component.scss']
})
export class CotizadorComponent implements OnInit {

  quoteForm: FormGroup;

  paises;
  selectPais;
  CitiesD: any[];
  CitiesO: any[];
  optionsCiudadesD: CiudadCotizador[];
  optionsCiudadesO: Ciudad[];
  filteredOptionsD: Observable<CiudadCotizador[]>;
  filteredOptionsO: Observable<Ciudad[]>;
  ciudadSelectedD: CiudadCotizador;
  ciudadSelectedO: Ciudad;

  showResult: boolean = false;
  showData: boolean = false;

  valorFinal;

  constructor(private formBuilder: FormBuilder, private ciudadesService: CiudadesService, private salesService: SalesService) {

    this.quoteForm = this.formBuilder.group({
      contraentrega: ['', Validators.required],
      pais: [''],
      ciudadO: ['', Validators.required],
      ciudadD: ['', Validators.required],
      valor: ['', [Validators.required, Validators.pattern('^([1-9][0-9]*|0)$'), Validators.min(0)]],
      peso: ['', [Validators.required, Validators.pattern('^[1-9][0-9]*$'), Validators.min(0), Validators.max(30)]],
      valto: ['', [Validators.required, Validators.pattern('^[1-9][0-9]*$'),/*  Validators.min(0), Validators.max(100) */]],
      vancho: ['', [Validators.required, Validators.pattern('^[1-9][0-9]*$'), /* Validators.min(0), Validators.max(100) */]],
      vprofundo: ['', [Validators.required, Validators.pattern('^[1-9][0-9]*$'), /* Validators.min(0), Validators.max(100) */]],
    });
  }

  ngOnInit(): void {
    this.loadPaises();
  }

  loadPaises(): void {
    this.ciudadesService.getPaises().subscribe((dataPais) => {
      let pos;
      this.paises = dataPais;
      this.paises.find((elem, index) => {
        if (elem.pais === 'Colombia') {
          pos = index;
        }
      })
      this.selectPais = this.paises[pos];
      this.loadCiudadesO(this.selectPais.pais);
      this.loadCiudadesD(this.selectPais.codigo_pais);
    });
  }

  selectPaisChange(e): void {
    // console.log('cambio', this.selectPais);
    this.loadCiudadesO(this.selectPais.pais);
    this.loadCiudadesD(this.selectPais.codigo_pais);
  }

  //TRAE VALORES DE LA CIUDAD
  loadCiudadesO(pais): void {
    this.ciudadesService.getCiudades(pais).subscribe((ciudades) => {
      this.optionsCiudadesO = ciudades;
      this.CitiesO = ciudades;
      console.log("Ciudades", this.CitiesO);
      this.addListenersO();
    });
  }

  loadCiudadesD(codigo_pais): void {
    this.ciudadesService.getCiudades2(codigo_pais).subscribe((ciudades) => {
      this.optionsCiudadesD = ciudades;
      this.CitiesD = ciudades;
      console.log("Ciudades", this.CitiesD);
      this.addListenersD();
    });
  }

  //TRAE VALORES DE LA CIUDAD
  addListenersD(): void {
    this.filteredOptionsD = this.quoteForm
      .get('ciudadD')
      .valueChanges.pipe(
        startWith(''),
        map((value) => {
          return this.ciudadFilterD(value);
        })
      );
  }

  addListenersO(): void {
    this.filteredOptionsO = this.quoteForm
      .get('ciudadO')
      .valueChanges.pipe(
        startWith(''),
        map((value) => {
          return this.ciudadFilterO(value);
        })
      );
  }

  //FILTRO DE CIUDAD
  private ciudadFilterD(ciudad: string): CiudadCotizador[] {
    ciudad = ciudad === null ? '' : ciudad;
    const filterValue = ciudad.toLowerCase();
    const filtered = this.optionsCiudadesD.filter((option) =>
      option.ciudad.toLowerCase().includes(filterValue)
    );
    if (filtered.length > 0) {
      return filtered;
    } else {
      this.quoteForm.get('ciudadD').setErrors({ required: true });
      return [];
    }
  }

  //FILTRO DE CIUDAD
  private ciudadFilterO(ciudad: string): Ciudad[] {
    ciudad = ciudad === null ? '' : ciudad;
    const filterValue = ciudad.toLowerCase();
    const filtered = this.optionsCiudadesO.filter((option) =>
      option.ciudad.toLowerCase().includes(filterValue)
    );
    if (filtered.length > 0) {
      return filtered;
    } else {
      this.quoteForm.get('ciudadO').setErrors({ required: true });
      return [];
    }
  }

  //OPCION SELECCIONADA EN CIUDAD
  onSelectedOptionD(ciudad: CiudadCotizador): void {
    this.ciudadSelectedD = ciudad;
  }

  //OPCION SELECCIONADA EN CIUDAD
  onSelectedOptionO(ciudad: Ciudad): void {
    this.ciudadSelectedO = ciudad;
  }

  codigoPais(): string {
    switch (this.selectPais.pais) {
      case 'Colombia':
        return '57';
        break;
      case 'Ecuador':
        return '593';
        break;
      case 'Mexico':
        return '52';
        break;
    }
  }

  cotiza(): void {
    if (this.quoteForm.valid) {
      this.showResult = true;
      this.showData = false;
      let valueForm = this.quoteForm.value;

      valueForm.ciudadD = this.ciudadSelectedD.id_ciudad;
      valueForm.ciudadO = this.ciudadSelectedO.id_centro_logistico;
      valueForm.pais = this.selectPais.codigo_pais;

      const object = this.setObjectQuote(valueForm);

      this.salesService.getCalcDelivery2(object).subscribe((data) => {
        this.valorFinal = data;
        this.valorFinal[0].valor_flete = this.setCoinDetail(valueForm.pais) + ' ' + this.setPointsCoin(data[0].valor_flete, valueForm.pais);
        this.valorFinal[1].valor_flete = this.setCoinDetail(valueForm.pais) + ' ' + this.setPointsCoin(data[1].valor_flete, valueForm.pais);
        this.valorFinal[2].valor_flete = this.setCoinDetail(valueForm.pais) + ' ' + this.setPointsCoin(data[2].valor_flete, valueForm.pais);
        this.showData = true;
        this.quoteForm.reset();
      });
    }
  }

  setObjectQuote(valueForm: formObject): cotizaObjeto {
    return {
      es_contraentrega: valueForm.contraentrega,
      id_ciudad_origen: valueForm.ciudadO,
      id_ciudad_destino: valueForm.ciudadD,
      peso: valueForm.peso,
      alto: valueForm.valto,
      ancho: valueForm.vancho,
      profundo: valueForm.vprofundo,
      valor_declarado: valueForm.valor,
      collect: valueForm.valor
    };
  }

  setCoinDetail(idCountry): String {
    if (idCountry === '57') {
      return 'COP';
    } else if (idCountry === '593' || idCountry === '1') {
      return 'USD';
    } else if (idCountry === '11') {
      return 'CAD';
    }
  }

  setPointsCoin(valor, idCountry): any {
    // VALORES MAYORES
    if (valor > 0) {
      /* COLOMBIA */
      if (idCountry === '57') {
        const valor2 = valor.toString();
        let valorFinal = valor2;
        let i;
        for (i = 0; i <= valorFinal.length; i++) {
          if (i === 4 || i === 8 || i === 12 || i === 16) {
            let num = i - 1;
            valorFinal = valorFinal.slice(0, valorFinal.length - num) + ',' + valorFinal.slice(-num);
          }
        }
        return valorFinal;
      } /* USA, CANADA, ECUADOR */
      else if (idCountry === '593' || idCountry === '1' || idCountry === '11') {
        const valor2 = valor.toString();
        let valor3 = valor2.replace(',', '.');
        let valorFinal = valor3.split('.');
        if (valorFinal.length > 1) {
          let vF1 = valorFinal[0];
          let decimalVF1 = valorFinal[1].slice(0, 2);
          for (let i = 0; i <= vF1.length; i++) {
            if (i === 4 || i === 8 || i === 12 || i === 16) {
              let num = i - 1;
              vF1 = vF1.slice(0, vF1.length - num) + ',' + vF1.slice(-num);
            }
          }
          vF1 = vF1 + '.' + decimalVF1;
          return vF1;
        } else {
          let vF2 = valorFinal[0];
          for (let i = 0; i <= vF2.length; i++) {
            if (i === 4 || i === 8 || i === 12 || i === 16) {
              let num = i - 1;
              vF2 = vF2.slice(0, vF2.length - num) + ',' + vF2.slice(-num);
            }
          }
          return vF2;
        }
      }
    } // VALORES MENORES 
    else if (valor < 0) {
      /* COLOMBIA */
      if (idCountry === '57') {
        const valor2 = valor.toString();
        let valorFinal = valor2.replace('-', '');
        let i;
        for (i = 0; i <= valorFinal.length; i++) {
          if (i === 4 || i === 8 || i === 12 || i === 16) {
            let num = i - 1;
            valorFinal = valorFinal.slice(0, valorFinal.length - num) + ',' + valorFinal.slice(-num);
          }
        }
        valorFinal = '-' + valorFinal;
        return valorFinal;
      } /* USA, CANADA, ECUADOR */
      else if (idCountry === '593' || idCountry === '1' || idCountry === '11') {
        const valor2 = valor.toString();
        let valor3 = valor2.replace(',', '.');
        let valor4 = valor3.replace('-', '');
        let valorFinal = valor4.split('.');
        if (valorFinal.length > 1) {
          let vF1 = valorFinal[0];
          let decimalVF1 = valorFinal[1].slice(0, 2);
          for (let i = 0; i <= vF1.length; i++) {
            if (i === 4 || i === 8 || i === 12 || i === 16) {
              let num = i - 1;
              vF1 = vF1.slice(0, vF1.length - num) + ',' + vF1.slice(-num);
            }
          }
          vF1 = '-' + vF1 + '.' + decimalVF1;
          return vF1;
        } else {
          let vF2 = valorFinal[0];
          for (let i = 0; i <= vF2.length; i++) {
            if (i === 4 || i === 8 || i === 12 || i === 16) {
              let num = i - 1;
              vF2 = vF2.slice(0, vF2.length - num) + ',' + vF2.slice(-num);
            }
          }
          vF2 = '-' + vF2;
          return vF2;
        }
      }
    } else {
      /* COLOMBIA */
      if (idCountry === '57') {
        const valor2 = valor;
        return valor2;
      } /* USA, CANADA, ECUADOR */
      else if (idCountry === '593' || idCountry === '1' || idCountry === '11') {
        const valor2 = valor;
        return valor2;
      }
    }

  }

}
